module.exports = __webpack_public_path__ + "static/media/hotel.49fd07aa.png";